// import { Component, OnInit } from '@angular/core';
// import { ActivatedRoute } from '@angular/router';
// import { ApiService } from './api.service';
// @Component({
//   selector: 'app-patient-detail',
//   templateUrl: './patient-detail.component.html',
//   styleUrls: ['./shared.css']
// })
// export class PatientDetailComponent implements OnInit {
//   patient: any = null;
//   visits: any[] = [];
//   audits: any[] = [];
//   trend: any[] = [];
//   constructor(private route: ActivatedRoute, private api: ApiService) {}
//   ngOnInit(): void {
//     const id = Number(this.route.snapshot.paramMap.get('id'));
//     this.api.getPatient(id).subscribe((res: any) => this.patient = res?.data);
//     this.api.getVisits(id).subscribe((res: any) => this.visits = res?.data || []);
//     this.api.getAudit(id).subscribe((res: any) => this.audits = res?.data || []);
//     this.api.getVitalsTrend(id).subscribe((res: any) => this.trend = res?.data || []);
//   }
//   trendPoints(): string {
//     if (!this.trend.length) return '';
//     const width = 560, height = 180, points: string[] = [], maxIndex = Math.max(1, this.trend.length - 1);
//     const maxVal = Math.max(...this.trend.map((r: any) => Number(r?.pulse || 0)), 1);
//     for (let i = 0; i < this.trend.length; i++) {
//       const x = i * (width / maxIndex) + 20;
//       const y = height - ((Number(this.trend[i]?.pulse || 0) / maxVal) * 140);
//       points.push(`${x},${y}`);
//     }
//     return points.join(' ');
//   }
// }

import { Component, numberAttribute, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { AssessmentService } from './assessment.service';
import { Demography, PatientAssessmentCase, UserRole, Vitals } from './patient-assessment.models';
import { Subscription } from 'rxjs';
import jsPDF from 'jspdf';
import {
  ChartData,
  ChartOptions
} from 'chart.js';


@Component({
  selector: 'app-doctor-dashboard',
  templateUrl: './doctor-dashboard.component.html',
  styleUrls: ['./doctor-dashboard.component.css']
})
export class PatientDetailComponent  {
  role: UserRole = 'Doctor';
  state: PatientAssessmentCase;
  demography: Demography;
  //vitals: Vitals;
  query = '';
  
  patients: any[] = [];
  filteredPatients: any[] = [];  // Search results
  selectedIndex = 0;
  searchText = '';
  

  vitalsList: any[] = [];
  user: any;
  email = "";
  
  showPatient = false;
  showVisitList = false;
  muteInfo = false;

  newpatientText = "New Patient";
  isVisitSaved = 0;
  visit_id = '';
  doctor_id = '';
  patient_id = '';
  patient_name = '';

  message = '';
  error = '';

  selectedPatient: any;

  visits:any[]=[];
  selectedVisit:any;


  // chiefComplaintsList: string[] = [];
  // medicalHistoryList: string[] = [];
  // selectedDiagnosesList: string[] = [];
  durationChiefComplaint: { [complaint: string]: string } = {};
  chiefComplaintsWithDuraton: string[] = [];

  //selectedInvestigations string[] = [];

  selectedInvestigations: string[] = [];
  resultOfInvestigations: { [invstigation: string]: string } = {};
  investigationsWithResults: string[] = [];

  allComplaints = [
    'Chest pain', 'Chest tightness', 'Shortness of breath', 'Cough', 'Fever',
    'Headache', 'Dizziness', 'Abdominal pain', 'Nausea / vomiting', 'Fatigue',
    'Weakness', 'Palpitations', 'Back pain', 'Joint pain', 'Swelling', 'Rash',
    'Sore throat', 'Weight loss', 'Polyuria', 'Polydipsia', 'Wound / infection',
    'Speech difficulty', 'Face droop', 'Trauma / injury'
  ];

  allHistory = [
    'Hypertension', 'Diabetes', 'Smoking', 'Asthma', 'COPD', 'Heart disease',
    'Kidney disease', 'Liver disease', 'Previous stroke', 'Cancer history',
    'Peptic ulcer / gastritis', 'Reflux disease', 'Pregnancy', 'Allergy to drugs',
    'Surgery history', 'Family history of heart disease', 'Family history of diabetes',
    'Family history of stroke', 'Infection history', 'Immunocompromised state'
  ];

//   heartRateChartData: ChartData<'line'> = {

//   labels: [
//     '10 Aug',
//     '11 Aug',
//     '12 Aug',
//     '13 Aug',
//     '14 Aug'
//   ],

//   datasets: [
//     {
//       label: 'Heart Rate',

//       data: [
//         72,
//         76,
//         74,
//         81,
//         78
//       ],

//       tension: 0.3,

//       pointRadius: 4
//     }
//   ]

// };


heartRateChartOptions: ChartOptions<'line'> = {

  responsive: true,

  maintainAspectRatio: false

};

  newComplaint = '';
  newHistory = '';
  newInvestigation = '';
  newAdvice = '';
  newDiagnosis = '';
  newTreatment = '';
  followUpDate = '';
  followUpNote = '';
  uploadedReportNames: string[] = [];
  private readonly subscription = new Subscription();

  constructor(public assessment: AssessmentService, public auth: AuthService, private api: ApiService, private router: Router, private route:ActivatedRoute) {
    this.state = this.assessment.snapshot;
    this.demography = { ...this.state.demography };
    //this.vitals = { ...this.state.vitals };
    this.subscription.add(this.assessment.case$.subscribe((s) => { this.state = s; this.demography = { ...s.demography }; })); ///this.vitals = { ...s.vitals }; }));
  }

  ngOnInit(){
        const userData = localStorage.getItem('user');
        if (userData) {
          this.user = JSON.parse(userData);
          this.loadDoctorProfile();

        }
        this.email = this.user.email;    
        this.doctor_id = this.user.id;
        this.filteredPatients = [];

        this.api.getPatientsByDoctor(Number(this.doctor_id))
          .subscribe((res: any) => {
            this.patients = res?.data || [];

            // User may have typed more characters while API was loading
            this.filterPatients();
          });
        
  }

  ngOnDestroy(): void { this.subscription.unsubscribe(); }
  onRoleChange(): void { this.assessment.setRole(this.role); }
  canEdit(section: 'demography' | 'vitals' | 'history' | 'diagnosis' | 'plans' | 'followup'): boolean {
    if (this.muteInfo == true) return false;
    if (this.role === 'Doctor') return true;
    if (this.role === 'Medical Assistant') return section === 'demography' || section === 'vitals' || section === 'history';
    if (this.role === 'Patient') return section === 'demography';
    return false;
  }

  showProfile = false;

  doctor:any = {};

  loadDoctorProfile()
  {

    this.profileSavedText = "";
    const user = JSON.parse(
        localStorage.getItem("user")!
    );

    this.api.getDoctorProfile(user.id).subscribe((res:any)=>{
                if(res.success){

                    this.doctor = res.data;


                }


            });

}

profileSavedText = "";
  saveProfile(){


      this.api.saveDoctorProfile(this.doctor).subscribe(()=>{
           this.profileSavedText = "Saved Successfully";
        
              //alert("Profile Saved");
          });

  }


  openProfile(){
      this.showProfile = true;
      this.loadDoctorProfile();
  }

  closeProfile(){
          this.showProfile = false;
  }


  // searchPatient(): void {
    
  //   const search = this.searchText.trim().toLowerCase();

  //   if(search.length == 0)
  //   {
  //     this.filteredPatients = [];
  //   }
    
  //   if (search.length == 1) 
  //   {
  //         this.api.getPatientsByDoctor(Number(this.doctor_id)).subscribe((res: any) => {
  //               this.patients = res?.data  ;   
  //               this.filteredPatients = [];
  //         });
  //   }

  //   if (search.length > 0) {
  //       this.showPatient = false;

  //       this.visits = [];
  //       this.showVisitList = false;
        
  //       this.patient_id = '';
  //       this.patient_name = '';
  //       this.visit_id = '';

  // }

  // if(search.length > 1)
  // {
  //   this.filteredPatients = this.patients.filter(patient =>

  //           patient.patient_code?.toLowerCase().includes(search) ||

  //           patient.full_name?.toLowerCase().includes(search) ||

  //           patient.phone?.toLowerCase().includes(search) ||

  //           patient.email?.toLowerCase().includes(search) ||

  //           patient.address?.toLowerCase().includes(search)

  //       );
  // }

  //   this.selectedIndex = 0;
    

  //     // if (this.searchText.trim().length < 2) {
  //     //     this.patients = [];
  //     //     return;
  //     // }

  //     // this.api.getPatients(this.searchText).subscribe((res: any) => {
  //     //   this.patients = res?.data || [];  
  //     // });

  // }

  searchPatient(): void {
  const search = this.searchText.trim().toLowerCase();

  // Reset current selection
  this.showPatient = false;
  this.visits = [];
  this.showVisitList = false;

  this.patient_id = '';
  this.patient_name = '';
  this.state.demography.fullName = '';
  this.visit_id = '';
  this.selectedIndex = 0;
  this.newpatientText = "New Patient";

  // // Empty search
  // if (search.length === 0) {
  //   this.filteredPatients = [];
  //   return;
  // }

  // First character: get the latest patient list
  if (search.length === 1) {
    this.filteredPatients = [];

    this.api.getPatientsByDoctor(Number(this.doctor_id))
      .subscribe((res: any) => {
        this.patients = res?.data || [];

        // User may have typed more characters while API was loading
        this.filterPatients();
      });

    return;
  }

  // 2+ characters
  this.filterPatients();
}

private filterPatients(): void {
  const search = this.searchText.trim().toLowerCase();

  // if (search.length < 2) {
  //   this.filteredPatients = [];
  //   return;
  // }

  this.filteredPatients = this.patients.filter(patient =>
    String(patient.patient_code ?? '').toLowerCase().includes(search) ||
    String(patient.full_name ?? '').toLowerCase().includes(search) ||
    String(patient.phone ?? '').toLowerCase().includes(search) ||
    String(patient.email ?? '').toLowerCase().includes(search) ||
    String(patient.address ?? '').toLowerCase().includes(search)
  );
}

handleKeyDown(event: KeyboardEvent): void {

    if (!this.filteredPatients.length)
        return;

    switch (event.key) {

        case 'ArrowDown':

            event.preventDefault();

            this.selectedIndex = Math.min(
                this.selectedIndex + 1,
                this.filteredPatients.length - 1
            );

            break;

        case 'ArrowUp':

            event.preventDefault();

            this.selectedIndex = Math.max(
                this.selectedIndex - 1,
                0
            );

            break;

        case 'Enter':
https://mail.google.com/mail/u/4?ui=2&ik=0fc708f2f6&attid=0.2&permmsgid=msg-f:1872514803188648817&th=19fc824ae0b84b71&view=att&zw&disp=inline
            event.preventDefault();

            this.selectPatient(
                this.filteredPatients[this.selectedIndex]
            );

            break;

        case 'Escape':

            this.filteredPatients = [];
            this.visits = [];

            break;
    }

}

selectPatient(patient:any){
    this.selectedPatient = patient;
    this.displayVitalCharts = false;
    
    this.selectedVisit = null;
    //this.patients = [];
    this.visits = [];

    //this.searchText = this.selectedPatient.patient_code + " : "+this.selectedPatient.full_name;
     this.searchText = `${patient.full_name}`;
        //`${patient.full_name} (${patient.patient_code})`;

    this.filteredPatients = [];
    
    this.patient_id = this.selectedPatient.patient_code;
    this.patient_name = this.selectedPatient.full_name;
    this.visit_id = '0';

     //this.doctor_id = this.user.id;

    this.state.demography.fullName = this.selectedPatient.full_name;
    this.state.demography.age = this.selectedPatient.age;
    this.state.demography.sex = this.selectedPatient.sex;
    this.state.demography.address = this.selectedPatient.address;
    this.state.demography.occupation = this.selectedPatient.occupation;
    this.state.demography.email = this.selectedPatient.email;
    this.state.demography.phone = this.selectedPatient.phone;

    this.clearVitalsVisits();


    this.loadVisits(this.selectedPatient.patient_code);
    //this.showVisitList = false;

    // Load vital trends
    this.loadPatientVitals(patient.id);
    //console.log(patient);

}

loadVitals(patientId:number){

    this.api.getVitals(patientId).subscribe((res:any)=>{
                        
            //this.trace = res?.message;

            this.vitalsList = res?.data || []; 
           
            
        });
}

loadVisits(patientId:number){
    this.api.getVisits(patientId).subscribe((res:any)=>{
            this.visits=res?.data || []; 
            //this.message = this.visits.length.toString() + "ash";
            
            // this.displayInfo();
            this.showVisitList = true;
            //this.showPatient = true;
            this.newpatientText = "Close Patient";

            this.loadVitals(this.selectedPatient.patient_code);

            
        });
}

selectedVital:any;

selectVisit(visit:any)
{
  this.displayVitalCharts = false;
  this.selectedVisit = visit;
  //this.selectedVital = null;

  this.selectedVital = this.vitalsList.find(v => v.visit_id == this.selectedVisit.visit_id);  


  this.visit_id = visit.visit_id;

  this.muteInfo = true;
  // this.message = "nello";
  
  this.showPatient = true;
  this.displayInfo();
}

trace:any;

displayInfo()
{
    // this.state.demography.fullName = this.selectedPatient.full_name;
    // this.state.demography.age = this.selectedPatient.age;
    // this.state.demography.sex = this.selectedPatient.sex;
    // this.state.demography.address = this.selectedPatient.address;
    // this.state.demography.occupation = this.selectedPatient.occupation;
    // this.state.demography.email = this.selectedPatient.email;
    // this.state.demography.phone = this.selectedPatient.phone;

    this.state.chiefComplaints = this.selectedVisit.complaint  ? JSON.parse(this.selectedVisit.complaint) : []; 
    this.state.medicalHistory = this.selectedVisit.history  ? JSON.parse(this.selectedVisit.history) : []; 
    this.state.selectedDiagnoses = this.selectedVisit.diagnosis ? JSON.parse(this.selectedVisit.diagnosis) : []; 
    //this.state.investigationPlan = this.selectedVisit.investigationPlan ? JSON.parse(this.selectedVisit.investigationPlan) : []; 
    this.state.advicePlan = this.selectedVisit.advice  ? JSON.parse(this.selectedVisit.advice) : []; 
    this.state.treatmentPlan = this.selectedVisit.treatment  ? JSON.parse(this.selectedVisit.treatment) : []; 
    this.selectedInvestigations = this.selectedVisit.investigations ? JSON.parse(this.selectedVisit.investigations) : [];
  

    this.state.vitals.bpSystolic= this.selectedVital.bp_systolic;// ? JSON.parse(this.selectedVital.bpSystolic) : null;
    this.state.vitals.bpDiastolic= this.selectedVital.bp_diastolic;// ? JSON.parse(this.selectedVital.bp_diastolic) : [];;
    this.state.vitals.pulse= this.selectedVital.pulse;// ? JSON.parse(this.selectedVital.pulse) : [];;
    this.state.vitals.temperature= this.selectedVital.temperature;// ? JSON.parse(this.selectedVital.temperature) : [];;
    this.state.vitals.respiratoryRate= this.selectedVital.respiratory_rate;// ? JSON.parse(this.selectedVital.respiratory_rate) : [];;
    this.state.vitals.spo2= this.selectedVital.spo2;// ? JSON.parse(this.selectedVital.spo2) : [];;
    this.state.vitals.weight= this.selectedVital.weight;// ? JSON.parse(this.selectedVital.weight) : [];;
    this.state.vitals.height= this.selectedVital.height;// ? JSON.parse(this.selectedVital.height) : [];;
    this.state.vitals.painScore= this.selectedVital.pain_score;// ? JSON.parse(this.selectedVital.pain_score) : [];;
   
    // this.loadVisits(patientId);
}

vitals: any[] = [];

displayVitalCharts = false;

showVitalCharts = false;


/* ============================
   CHART OPTIONS
   ============================ */

vitalChartOptions: ChartOptions<'line'> = {

  responsive: true,
  maintainAspectRatio: false,

  interaction: {
    intersect: false,
    mode: 'index'
  },

  plugins: {

    legend: {
      display: false
    },

    tooltip: {
      enabled: true
    }

  },

  scales: {

    x: {
      grid: {
        display: false
      }
    },

    y: {
      beginAtZero: false
    }

  }

};


/* Blood pressure needs legend */

bpChartOptions: ChartOptions<'line'> = {

  responsive: true,
  maintainAspectRatio: false,

  interaction: {
    intersect: false,
    mode: 'index'
  },

  plugins: {

    legend: {
      display: true,
      position: 'top'
    }

  },

  scales: {

    x: {
      grid: {
        display: false
      }
    },

    y: {
      beginAtZero: false
    }

  }

};


/* ============================
   CHART DATA
   ============================ */

bpChartData: ChartData<'line'> = {
  labels: [],
  datasets: []
};

heartRateChartData: ChartData<'line'> = {
  labels: [],
  datasets: []
};

temperatureChartData: ChartData<'line'> = {
  labels: [],
  datasets: []
};

spo2ChartData: ChartData<'line'> = {
  labels: [],
  datasets: []
};

respiratoryChartData: ChartData<'line'> = {
  labels: [],
  datasets: []
};

weightChartData: ChartData<'line'> = {
  labels: [],
  datasets: []
};

get latestVital(): any {

  if (!this.vitals?.length) {
    return null;
  }

  return this.vitals[
    this.vitals.length - 1
  ];
}

formatVitalDate(date: string): string {

  if (!date) {
    return '';
  }

  return new Date(date)
    .toLocaleDateString(
      'en-GB',
      {
        day: '2-digit',
        month: 'short'
      }
    );
}

toChartValue(value: any): number | null {

  if (
    value === null ||
    value === undefined ||
    value === ''
  ) {
    return null;
  }

  const n = Number(value);

  return Number.isFinite(n)
    ? n
    : null;
}

prepareVitalCharts(): void {

  const labels = this.vitals.map(v =>
    this.formatVitalDate(v.created_at)
  );


  /* ========================
     BLOOD PRESSURE
     ======================== */

  this.bpChartData = {

    labels,

    datasets: [

      {
        label: 'Systolic',

        data: this.vitals.map(v =>
          this.toChartValue(v.bp_systolic)
        ),

        tension: 0.3,
        pointRadius: 3,
        spanGaps: true
      },

      {
        label: 'Diastolic',

        data: this.vitals.map(v =>
          this.toChartValue(v.bp_diastolic)
        ),

        tension: 0.3,
        pointRadius: 3,
        spanGaps: true
      }

    ]

  };


  /* ========================
     HEART RATE
     ======================== */

  this.heartRateChartData = {

    labels,

    datasets: [

      {
        label: 'Heart Rate',

        data: this.vitals.map(v =>
          this.toChartValue(v.pulse)
        ),

        tension: 0.3,
        pointRadius: 3,
        spanGaps: true
      }

    ]

  };


  /* ========================
     TEMPERATURE
     ======================== */

  this.temperatureChartData = {

    labels,

    datasets: [

      {
        label: 'Temperature',

        data: this.vitals.map(v =>
          this.toChartValue(v.temperature)
        ),

        tension: 0.3,
        pointRadius: 3,
        spanGaps: true
      }

    ]

  };


  /* ========================
     SpO2
     ======================== */

  this.spo2ChartData = {

    labels,

    datasets: [

      {
        label: 'SpO₂',

        data: this.vitals.map(v =>
          this.toChartValue(v.spo2)
        ),

        tension: 0.3,
        pointRadius: 3,
        spanGaps: true
      }

    ]

  };


  /* ========================
     RESPIRATORY RATE
     ======================== */

  this.respiratoryChartData = {

    labels,

    datasets: [

      {
        label: 'Respiratory Rate',

        data: this.vitals.map(v =>
          this.toChartValue(v.respiratory_rate)
        ),

        tension: 0.3,
        pointRadius: 3,
        spanGaps: true
      }

    ]

  };


  /* ========================
     WEIGHT
     ======================== */

  this.weightChartData = {

    labels,

    datasets: [

      {
        label: 'Weight',

        data: this.vitals.map(v =>
          this.toChartValue(v.weight)
        ),

        tension: 0.3,
        pointRadius: 3,
        spanGaps: true
      }

    ]

  };

}

loadPatientVitals(patientId: number): void {

  this.showVitalCharts = false;

  this.api.getVitals(patientId).subscribe({

      next: (res: any) => {

        this.vitals = res?.data || [];

        if (this.vitals.length > 0) {

          this.prepareVitalCharts();

          this.showVitalCharts = true;

        }

      },

      error: (err) => {

        console.error(
          'Error loading patient vitals:',
          err
        );

        this.vitals = [];
        this.showVitalCharts = false;

      }

    });
}

newVisit()
{
  this.muteInfo = false;
  //this.message = "hello";
  this.visit_id = '';
  this.showPatient = true;
  this.selectedVisit = null;

  //this.doctor_id = this.user.id;

  this.state.demography.fullName = this.selectedPatient.full_name;
  this.state.demography.age = this.selectedPatient.age;
  this.state.demography.sex = this.selectedPatient.sex;
  this.state.demography.address = this.selectedPatient.address;
  this.state.demography.occupation = this.selectedPatient.occupation;
  this.state.demography.email = this.selectedPatient.email;
  this.state.demography.phone = this.selectedPatient.phone;

 

}

// selectVisit(visit:any){

//     this.selectedVisit=visit;

//     this.loadVitals(visit.id);

//     this.loadChiefComplaints(visit.id);

//     this.loadHistory(visit.id);

//     this.loadExamination(visit.id);

//     this.loadDiagnosis(visit.id);

//     this.loadPrescription(visit.id);

// }

  // searchPatient(): void {
  //   // this.api.getPatients(this.query).subscribe((res: any) => {
  //   //   this.message = res?.data || [];
      
  //   // });
  // }

  profile():void
  {

  }

  newPatient():void
  {
   

    this.muteInfo = false;
    this.showVisitList = false;
    this.searchText = "";
    this.displayVitalCharts = false;


     if(this.visits.length > 0)
      {
        this.showPatient = false;
        this.newpatientText = "New Patient";
        this.visits = [];
        this.filteredPatients = [];
        this.visit_id = '';
        this.patient_name = '';
        this.state.demography.fullName = '';
        this.patient_id = '';
        this.clearUI();
        
       this.filterPatients();

        return;
      }

    if(this.showPatient)
    {
      this.showPatient = false;
      this.newpatientText = "New Patient";
      this.isVisitSaved = 0;
      this.visit_id = '';
      this.patient_name = '';
      this.state.demography.fullName = '';
      //this.doctor_id = '';
      this.patient_id = '';

      this.message = '';
      this.error = '';

      this.filterPatients();

      

    }
    else if(!this.showPatient)
    {

      this.showPatient = true;
      this.newpatientText = "Close Patient";
     
      this.clearUI();

      this.updateDemography();

    }

  }

  clearVitalsVisits()
  {
    this.state.vitals.bpSystolic = null;
    this.state.vitals.bpDiastolic = null;
    this.state.vitals.pulse = null;
    this.state.vitals.temperature = null;
    this.state.vitals.respiratoryRate = null;
    this.state.vitals.spo2 = null;
    this.state.vitals.weight = null;
    this.state.vitals.height = null;
    this.state.vitals.painScore = null;

    this.state.chiefComplaints = [];
    this.state.medicalHistory = [];
    this.state.selectedDiagnoses = [];
    this.state.investigationPlan = [];
    this.state.advicePlan = [];
    this.state.treatmentPlan = [];
    this.selectedInvestigations = [];
    this.filteredPatients = [];
  }
  
  
  private clearUI() {
    this.state.demography.patientId = ""; //getNewPatientID(this.doctor_id);
    this.state.demography.fullName = "";
    this.state.demography.email = "";
    this.state.demography.phone = "";
    this.state.demography.address = "";
    this.state.demography.occupation = "";
    this.state.demography.sex = "";
    this.state.demography.age = null;

    this.clearVitalsVisits();
  }

  updateDemography(): void { this.assessment.updateDemography(this.demography); }
  //updateVitals(): void { this.assessment.updateVitals(this.vitals); }
  toggleComplaint(value: string): void { if (!this.canEdit('history')) return; if (this.state.chiefComplaints.includes(value)) this.assessment.removeChiefComplaint(this.state.chiefComplaints.indexOf(value)); else this.assessment.addChiefComplaint(value); }
  toggleHistory(value: string): void { if (!this.canEdit('history')) return; if (this.state.medicalHistory.includes(value)) this.assessment.removeMedicalHistory(this.state.medicalHistory.indexOf(value)); else this.assessment.addMedicalHistory(value); }
  toggleInvestigation(value: string): void { if (!this.canEdit('history')) return; if (this.selectedInvestigations.includes(value)) this.selectedInvestigations = this.selectedInvestigations.filter(item => item !== value); else this.selectedInvestigations.push(value);}
  addComplaint(): void { this.assessment.addChiefComplaint(this.newComplaint); this.newComplaint = ''; }
  addHistory(): void { this.assessment.addMedicalHistory(this.newHistory); this.newHistory = ''; }
  addDiagnosis(): void { this.assessment.addMedicalDiagnosis(this.newDiagnosis); this.newDiagnosis = ''; }
  removeHistory(index: number): void { this.assessment.removeMedicalHistory(index); }
  toggleDiagnosis(name: string): void { if (this.canEdit('diagnosis')) this.assessment.toggleDiagnosis(name); }
  
  addInvestigation(): void { this.selectedInvestigations.push(this.newInvestigation); this.newInvestigation = ''; }
  //deleteInvestigation(): 
  
  removeInvestigation(value: string): void { if (this.selectedInvestigations.includes(value)) this.selectedInvestigations = this.selectedInvestigations.filter(item => item !== value); }
  addAdvice(): void { this.assessment.addAdvice(this.newAdvice); this.newAdvice = ''; }
  removeAdvice(index: number): void { this.assessment.removeAdvice(index); }
  addTreatment(): void { this.assessment.addTreatment(this.newTreatment); this.newTreatment = ''; }
  removeTreatment(index: number): void { this.assessment.removeTreatment(index); }
  onReportsSelected(event: Event): void { const input = event.target as HTMLInputElement; const files = Array.from(input.files ?? []); this.uploadedReportNames = files.map((f) => f.name); }
  saveFollowUp(): void { if (!this.canEdit('followup')) return; this.assessment.scheduleFollowUp(this.followUpDate, this.followUpNote, this.uploadedReportNames); this.followUpDate = ''; this.followUpNote = ''; this.uploadedReportNames = []; }
  trackByIndex(index: number): number { return index; }

  editingComplaint = -1;
  complaintDuration = "";
  
  removeComplaint(index: number): void { 
    this.assessment.removeChiefComplaint(index); 
  }
  
  editComplaint(index: number): void {
    this.editingComplaint = index; 
    //this.complaintDuration = this.state.chiefComplaints[index].duration;
  }
  
  saveComplaintDuration(): void {
    if (this.editingComplaint < 0) return;
    //this.state.chiefComplaints[this.editingComplaint].duration = this.complaintDuration;
    this.durationChiefComplaint[this.state.chiefComplaints[this.editingComplaint]] =   this.complaintDuration;
    //= this.state.chiefComplaints[this.editingComplaint] + " ("+ this.complaintDuration +" days)";
    this.editingComplaint = -1;
    this.complaintDuration = "";
  }

  editingInvestigation = -1;
  investigationResult = "";

  editInvestigation(index: number): void {
    this.editingInvestigation = index; 
    //this.complaintDuration = this.state.chiefComplaints[index].duration;
  }
  
  saveInvestigationResult(): void {
    if (this.editingInvestigation < 0) return;
    //this.state.chiefComplaints[this.editingComplaint].duration = this.complaintDuration;
    this.resultOfInvestigations[this.selectedInvestigations[this.editingInvestigation]] =   this.investigationResult;
    //= this.state.chiefComplaints[this.editingComplaint] + " ("+ this.complaintDuration +" days)";
    this.editingInvestigation = -1;
    this.investigationResult = "";
  }

  saveDemoInfo(level:any):void{
    //this.demography.patientId = this.patient_id;
    //this.updateDemography();
    
    this.error = '';
    this.message = '' ;
    if(this.patient_id == '')
      this.patient_id = '0';
    // this.trace = this.patient_id+" aa ";

    //patient_code, full_name, age, sex, phone, email, address, occupation, assigned_doctor_id
    this.api.savePatient({  patient_code: this.patient_id , 
                            full_name: this.state.demography.fullName, 
                            age: this.state.demography.age, 
                            sex: this.state.demography.sex, 
                            phone: this.state.demography.phone,
                            email: this.state.demography.email,
                            address: this.state.demography.address,
                            occupation:this.state.demography.occupation, 
                            assigned_doctor_id: this.doctor_id
                        }).subscribe({
                            next: (res: any) => {
                              this.message = res?.message || 'Save Demography successful';
                              if(res?.id)
                              {
                                //this.demography.patientId = res?.id;
                                this.patient_id = res?.id;
                              }
                              if(level == 2)
                              {
                                this.saveVitalsInfo(level);
                              }
                              if(level == 3)
                              {
                                this.saveVitalsInfo(level);
                                //this.saveVisitInfo();
                              }
                            },
                            error: (err) => this.error = err?.error?.error || 'Demography Save failed!'
                          });
    }

  saveVitalsInfo(level:any):void
  {
        //patient_id, doctor_id, visit_id, bp_systolic, bp_diastolic, pulse, temperature, respiratory_rate, spo2, weight, height, pain_score
      
    //this.updateVitals();
    this.error = '';
    this.message = '';
   
    this.api.saveVitals({  patient_id: this.patient_id, 
                           doctor_id: this.doctor_id,
                           visit_id: this.visit_id, 
                            bp_systolic: this.state.vitals.bpSystolic, 
                            bp_diastolic: this.state.vitals.bpDiastolic, 
                            pulse: this.state.vitals.pulse,
                            temperature: this.state.vitals.temperature,
                            respiratory_rate: this.state.vitals.respiratoryRate,
                            spo2:this.state.vitals.spo2, 
                            weight: this.state.vitals.weight,
                            height: this.state.vitals.height,
                            pain_score: this.state.vitals.painScore
                        }).subscribe({
                            next: (res: any) => {
                              this.message = res?.message || 'Save Vital Info successful';
                              if(res?.visit_id)
                              {
                                this.visit_id = res?.visit_id;
                                

                              }
                              if(level == 3)
                              {
                                this.saveVisitInfo();
                              }
                            },
                            error: (err) => this.error = err?.error?.error || 'Vitals Save failed!'
                          });
    }

 
  includeResultsWithInvestigations()
  {
    this.selectedInvestigations.forEach( (item,index) => {
       if(this.resultOfInvestigations[item] != null)
        this.investigationsWithResults[index] = this.selectedInvestigations[index] + " : "+this.resultOfInvestigations[item];
    }
    );
  }

  includeDaysWithComplaints()
  {
    this.state.chiefComplaints.forEach( (item,index) => {
       if(this.durationChiefComplaint[item] != null)
        this.chiefComplaintsWithDuraton[index] = this.state.chiefComplaints[index] + " ("+this.durationChiefComplaint[item]+" days)";
    }
    );
  }

  

  
  saveVisitInfo():void{
    this.error = '';
    this.message = '';
    this.includeResultsWithInvestigations();
    this.includeDaysWithComplaints();


    //patient_id, visit_number, visit_datetime, doctor_id, complaint, history, diagnosis, investigations, advice, treatment
    this.api.saveVisit({ 
                         visit_saved: this.isVisitSaved,
                         patient_id: this.patient_id, 
                         visit_id: this.visit_id,
                         doctor_id: this.doctor_id, 
                         user_id: this.user.id, 
                         complaint: this.chiefComplaintsWithDuraton, 
                         history: this.state.medicalHistory,
                         diagnosis: this.state.selectedDiagnoses,
                         investigations: this.investigationsWithResults,
                         advice:this.state.advicePlan, 
                         treatment: this.state.treatmentPlan,
                         vitals: this.state.vitals
                        }).subscribe({
                            next: (res: any) => {
                              this.message = res?.message || 'Visit Info Save successful';
                              this.isVisitSaved = res?.isVisitSaved;
                              this.error = res?.error;

                              //this.clearUI();
                              this.visits = [];
                              this.loadVisits(this.selectedPatient.patient_code);
                              
                              this.api.getPatientsByDoctor(Number(this.doctor_id))
                                .subscribe((res: any) => {
                                  this.patients = res?.data || [];
                                });
                            },
                            error: (err) => this.error = err?.error?.error || 'Visit Info Save failed'
                          });
    }


  logout(): void {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  private arrayBufferToBinary(buffer: ArrayBuffer): string {

    let binary = '';

    const bytes = new Uint8Array(buffer);

    const len = bytes.byteLength;

    for(let i=0;i<len;i++){

        binary += String.fromCharCode(bytes[i]);

    }

    return binary;
}

  async generatePdf() {

  const doc = new jsPDF();

  const font = await fetch('assets/fonts/NotoSansBengali-Regular.ttf')
      .then(r => r.arrayBuffer());

  const binary = this.arrayBufferToBinary(font);

  doc.addFileToVFS(
      'NotoSansBengali-Regular.ttf',
      binary
  );

  doc.addFont(
      'NotoSansBengali-Regular.ttf',
      'Bangla',
      'normal'
  );

  doc.setFont('Bangla');

  doc.text('রোগীর নাম রোগীর নাম প্রধান উপসর্গ',20,20);

  doc.save('test.pdf');
}


private printHeader(doc: jsPDF) {

    doc.setFillColor(25, 118, 210);

    doc.rect(0,0,210,22,"F");

    doc.setTextColor(255);

    doc.setFontSize(18);

    doc.setFont("helvetica","bold");

    doc.text("VisitPhy",105,10,{align:"center"});

    doc.setFontSize(11);

    doc.text(
        "Prescription",
        105,
        17,
        {align:"center"}
    );

    doc.setTextColor(0);

}

private printPatientInfo(doc: jsPDF,y:number){

    doc.setDrawColor(180);

    doc.rect(10,y,190,24);

    doc.setFontSize(11);

    doc.setFont("helvetica","bold");

    doc.text("Patient ID",15,y+6);

    doc.text("Name",70,y+6);

    doc.text("Age",150,y+6);

    doc.text("Gender",175,y+6);

    doc.setFont("helvetica","normal");

    doc.text(this.patient_id,15,y+12);

    doc.text(this.state.demography.fullName,70,y+12);

    doc.text(String(this.state.demography.age),150,y+12);

    doc.text(this.state.demography.sex,175,y+12);

}

private section(doc:jsPDF,title:string,y:number){

    //doc.setFillColor("152535");

    doc.rect(10,y,190,7);

    doc.setFont("helvetica","bold");

    doc.text(title,13,y+5);

    doc.setFont("helvetica","normal");

}

private bullet(doc:jsPDF, text:string, y:number)
{

  doc.circle(15,y-1,.6,"F");

  doc.text(text,20,y);

}

generatePrescription(): void {

  const doc = new jsPDF();

  let y = 10;

  // ==========================
  // Header
  // ==========================

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.text("Dr. "+this.doctor.full_name+", "+this.doctor.specialization, 170, y, { align: "center" });
  doc.text(this.doctor.clinic+ ", "+this.doctor.chamber_address, 170, y+4, { align: "center" });
  doc.text("Phone: "+this.doctor.phone, 170, y+8, { align: "center" });
  doc.text("Email: "+this.doctor.email, 170, y+12, { align: "center" });


  y = 15
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("VisitoCare", 105, y, { align: "center" });




  y += 8;

  doc.setFontSize(12);
  doc.text("Patient Prescription", 105, y, { align: "center" });

  y += 8;

  doc.line(10, y, 200, y);

  y += 8;

  // ==========================
  // Patient Information
  // ==========================

  doc.setFontSize(11);

  doc.text(`Patient ID : ${this.patient_id}`, 10, y);
  doc.text(`Date : ${new Date().toLocaleDateString()}`, 140, y);

  y += 6;

  doc.text(`Name : ${this.state.demography.fullName}`, 10, y);
  doc.text(`Age : ${this.state.demography.age}`, 140, y);

  y += 6;

  doc.text(`Gender : ${this.state.demography.sex}`, 10, y);

  y += 8;

  doc.line(10, y, 200, y);

  y += 8;

  // ==========================
  // Two Columns
  // ==========================

  let leftX = 10;
  let rightX = 110;

  let leftY = y;
  let rightY = y;

  // ==========================
  // LEFT COLUMN
  // ==========================

  doc.setFont("helvetica", "bold");
  doc.text("Vital Signs", leftX, leftY);

  leftY += 6;

  doc.setFont("helvetica", "normal");

  doc.text(
      `BP : ${this.state.vitals.bpSystolic}/${this.state.vitals.bpDiastolic}`,
      leftX,
      leftY
  );

  leftY += 5;

  doc.text(
      `Pulse : ${this.state.vitals.pulse}`,
      leftX,
      leftY
  );

  leftY += 5;

  doc.text(
      `Temp : ${this.state.vitals.temperature}`,
      leftX,
      leftY
  );

  leftY += 5;

  doc.text(
      `Spo2 : ${this.state.vitals.spo2}`,
      leftX,
      leftY
  );

  leftY += 10;

  // Chief Complaints

  doc.setFont("helvetica", "bold");
  doc.text("Chief Complaints", leftX, leftY);

  leftY += 6;

  doc.setFont("helvetica", "normal");

  this.state.chiefComplaints.forEach(item => {

      doc.text(
          "• " + item +
          (this.durationChiefComplaint[item]
              ? ` (${this.durationChiefComplaint[item]} Days)`
              : ""),
          leftX + 3,
          leftY
      );

      leftY += 5;

  });

  leftY += 5;

  // Medical History

  doc.setFont("helvetica", "bold");
  doc.text("Medical History", leftX, leftY);

  leftY += 6;

  doc.setFont("helvetica", "normal");

  this.state.medicalHistory.forEach(item => {

      doc.text("• " + item, leftX + 3, leftY);

      leftY += 5;

  });

  leftY += 5;

  // Diagnosis

  doc.setFont("helvetica", "bold");
  doc.text("Diagnosis", leftX, leftY);

  leftY += 6;

  doc.setFont("helvetica", "normal");

  this.state.selectedDiagnoses.forEach(item => {

      doc.text("• " + item, leftX + 3, leftY);

      leftY += 5;

  });

  leftY += 5;

  // Advice

  doc.setFont("helvetica", "bold");
  doc.text("Advice", leftX, leftY);

  leftY += 6;

  doc.setFont("helvetica", "normal");

  this.state.advicePlan.forEach(item => {

      doc.text("• " + item, leftX, leftY);

      leftY += 5;

  });
  

  // ==========================
  // RIGHT COLUMN
  // ==========================

  doc.setFont("helvetica", "bold");
  doc.text("Rx", rightX, rightY);

  rightY += 8;

  doc.setFont("helvetica", "normal");

  this.state.treatmentPlan.forEach((item, index) => {

      doc.text(`${index + 1}. ${item}`, rightX, rightY);

      rightY += 6;

  });

  rightY += 6;

  doc.setFont("helvetica", "bold");
  doc.text("Investigation", rightX, rightY);

  rightY += 6;

  doc.setFont("helvetica", "normal");

  this.state.investigationPlan.forEach(item => {

      doc.text("□ " + item, rightX + 3, rightY);

      rightY += 5;

  });

  rightY += 6;

  if (this.followUpDate) {

      doc.setFont("helvetica", "bold");
      doc.text("Follow Up", rightX, rightY);

      rightY += 6;

      doc.setFont("helvetica", "normal");
      doc.text(this.followUpDate, rightX, rightY);

      rightY += 5;

      if (this.followUpNote) {

          doc.text(this.followUpNote, rightX, rightY);

      }

  }

  // ==========================
  // Signature
  // ==========================

  doc.line(120, 265, 190, 265);

  doc.setFont("helvetica", "bold");
  doc.text("Doctor's Signature", 145, 272);
  
  // doc.setFont("helvetica", "bold");
  // doc.text("Doctor's Signature", 145, 272);
  // doc.text(this.doctor.clinic+" , "+this.doctor.chamber_address, 145, 280);
  // doc.text("Phone: "+this.doctor.phone+" , Email: "+this.doctor.email, 145, 288);

  // ==========================
  // Save
  // ==========================

  doc.save(
      `Prescription_${this.demography.patientId}.pdf`
  );

}


generatePrescription3(): void {

  this.muteInfo = false;
  const doc = new jsPDF();
  this.printHeader(doc);
  this.printPatientInfo(doc,30);
  this.section(doc,"Vitals",65);
  this.bullet(doc,`BP: ${this.state.vitals.bpSystolic}/${this.state.vitals.bpDiastolic}`, 80);
  this.bullet(doc,`Pulse: ${this.state.vitals.pulse}`, 85);
  this.bullet(doc,`Temperature: ${this.state.vitals.temperature}`, 90);
  this.bullet(doc,`SpO2: ${this.state.vitals.spo2}`, 95);

  this.section(doc,"Chief Complaints",105);
  let x = 120;
  this.state.chiefComplaints.forEach(c => {
    this.bullet(doc,` ${c}`, x);
    x += 5;
  });

   x += 10;
  this.section(doc,"MEDICAL HISTORY",x);
  this.state.medicalHistory.forEach(c => {
    this.bullet(doc,` ${c}`, x);
    x += 5;
  });
   x += 10;
 
  this.section(doc,"PROVISIONAL DIAGNOSIS",x);
  this.state.selectedDiagnoses.forEach(c => {
    this.bullet(doc,` ${c}`, x);
    x += 5;
  });
   x += 10;

  this.section(doc,"INVESTIGATIONS",x);
  this.state.investigationPlan.forEach(c => {
    this.bullet(doc,` ${c}`, x);
    x += 5;
  });
   x += 10;


  const filename =
    `Prescription_${this.state.demography.patientId}_${new Date().getTime()}.pdf`;

  doc.save(filename);

}
generatePrescription2(): void {

  this.muteInfo = false;

  const doc = new jsPDF();

  let y = 20;

  doc.setFontSize(18);
  doc.text('PATIENT PRESCRIPTION', 70, y);

  y += 15;

  doc.setFontSize(12);

  doc.text(`Patient ID: ${this.demography.patientId}`, 10, y);
  y += 8;

  doc.text(`Patient Name: ${this.demography.fullName}`, 10, y);
  y += 8;

  doc.text(`Age: ${this.demography.age}`, 10, y);
  y += 8;

  doc.text(`Gender: ${this.demography.sex}`, 10, y);
  y += 12;

  doc.text('VITAL SIGNS', 10, y);
  y += 8;

  doc.text(`BP: ${this.state.vitals.bpSystolic}/${this.state.vitals.bpDiastolic}`, 10, y);
  y += 8;

  doc.text(`Pulse: ${this.state.vitals.pulse}`, 10, y);
  y += 8;

  doc.text(`Temperature: ${this.state.vitals.temperature}`, 10, y);
  y += 8;

  doc.text(`SpO2: ${this.state.vitals.spo2}`, 10, y);
  y += 12;

  doc.text('CHIEF COMPLAINTS', 10, y);
  y += 8;

  this.state.chiefComplaints.forEach(c => {
    doc.text(`• ${c} (${this.durationChiefComplaint[c]} days)`, 15, y);
    y += 6;
  });

  y += 6;

  doc.text('MEDICAL HISTORY', 10, y);
  y += 8;

  this.state.medicalHistory.forEach(h => {
    doc.text(`• ${h}`, 15, y);
    y += 6;
  });

  y += 6;

  doc.text('PROVISIONAL DIAGNOSIS', 10, y);
  y += 8;

  this.state.selectedDiagnoses.forEach(d => {
    doc.text(`• ${d}`, 15, y);
    y += 6;
  });

  y += 6;

  doc.text('INVESTIGATIONS', 10, y);
  y += 8;

  this.state.investigationPlan.forEach(i => {
    doc.text(`• ${i}`, 15, y);
    y += 6;
  });

  y += 6;

  doc.text('ADVICE', 10, y);
  y += 8;

  this.state.advicePlan.forEach(a => {
    doc.text(`• ${a}`, 15, y);
    y += 6;
  });

  y += 6;

  doc.text('TREATMENT PLAN', 10, y);
  y += 8;

  this.state.treatmentPlan.forEach(t => {
    doc.text(`• ${t}`, 15, y);
    y += 6;
  });

  y += 10;

  if (this.followUpDate) {
    doc.text(`Follow-up Date: ${this.followUpDate}`, 10, y);
    y += 8;
  }

  if (this.followUpNote) {
    doc.text(`Follow-up Note: ${this.followUpNote}`, 10, y);
    y += 8;
  }

  const filename =
    `Prescription_${this.demography.patientId}_${new Date().getTime()}.pdf`;

  doc.save(filename);
}}


